import { ServiceResponse } from '@nx-smartmonkey/shared/hooks';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';

import { revenueCatService } from '../../application/RevenueCatService';
import { sessionService } from '../../application/SessionService';
import { intercom } from '../../services';

type UseSessionLogoutResponseProps = ServiceResponse<() => void, void>;

// Hooks act as 'Adapter' layer.
export const useSessionLogout = (): UseSessionLogoutResponseProps => {
  const queryClient = useQueryClient();
  const { isSuccess, isError, isLoading, mutate } = useMutation(() => sessionService.deleteSessionToken());

  useEffect(() => {
    if (isSuccess) {
      intercom.logout();
      revenueCatService.logOut();
      queryClient.clear();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess]);

  return {
    success: isSuccess,
    error: isError,
    isLoading,
    run: mutate,
  };
};
